import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { ConsoleLoggerService } from '../../service/console-logger.service';

@Component({
  selector: 'wim-logout',
  standalone: true,
  imports: [],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss'
})
export class LogoutComponent implements OnInit {


  constructor(private oauthService: OAuthService, private consoleLoggerService: ConsoleLoggerService) {
  }

  ngOnInit(): void {
    this.consoleLoggerService.debug('log out');
    this.oauthService.logOut()
  }

}
